import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import SubscriptionList from "../partials/list/SubscriptionList";
import { BoxContainer } from '../layouts/Theme';
import { useI18N } from '../context/I18NContext';
export default function Subscriptions(props) {
    const { t } = useI18N();
    const theme = useTheme();
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { sx: { color: theme.palette.text.primary }, variant: "h6", children: t('Strippenkaarten en abonnementen') }), _jsx(SubscriptionList, {})] }));
}
